module.exports = __webpack_public_path__ + "img/caishen_900.fd561f5d.png";